module.exports = __webpack_public_path__ + "img/YouLostMailBackground2_1920x3240.29ac2de7.jpg";